import {
  JP_GET_STREAM_ID,
  JP_CONNECT,
  JP_ACCEPT_WIN,
  JP_MARK_WIN_AS_VIEWED,
} from "../constants";

export const getWebSocketStream = (isCreateConnection = true) => ({
  type: JP_GET_STREAM_ID,
  payload: { isCreateConnection },
});

export const connectToWebSocket = (streamId) => ({
  type: JP_CONNECT,
  payload: { streamId },
});

export const markWinAsViewed = (winId) => ({
  type: JP_MARK_WIN_AS_VIEWED,
  payload: { winId },
});

export const acceptWin = (winId) => ({
  type: JP_ACCEPT_WIN,
  payload: { winId },
});
